import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=6672cb1e"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default,Theme5MobileNotificationModal: require('/app/components/Theme5/Mobile/NotificationModal.vue').default,Theme5ComponentsSwitchLanguage: require('/app/components/Theme5/Components/SwitchLanguage.vue').default,Theme5SideNav: require('/app/components/Theme5/SideNav.vue').default,CommonsThemeMode: require('/app/components/Commons/ThemeMode.vue').default})
